
require.register("readable-stream/writable-browser.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {"util":false}, "readable-stream");
  (function() {
    module.exports = require('./lib/_stream_writable.js');
  })();
});